import ReportTemplateForm from '@components/admin/reportTemplates/ReportTemplateForm'
import { Loading } from '@rd-web-markets/shared/dist/util';
import claimGroupService from '@rd-web-markets/shared/dist/services/claim_group.service';
import claimGroupReportTemplateService from '@rd-web-markets/shared/dist/services/claim_group_report_templates.service';
import React, { useState, useEffect } from 'react'
import { Breadcrumb, Card, Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Link, useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import reportTemplateCategoryService from '@rd-web-markets/shared/dist/services/report_templates/report_template_category.service';
import { REPORT_SAVE_PARAM, USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import SidebarPortal from '@rd-web-markets/shared/dist/util/SidebarPortal';
import reportTemplateService from '@rd-web-markets/shared/dist/services/report_template.service';
import ClaimGroupSidebarV2 from '@rd-web-markets/shared/dist/pages/setup/ClaimGroupSidebarV2';

const EditClaimGroupReportTemplatePage = ({handleToaster, accountType}) => {
  const { claim_group_id, id } = useParams();
  const [loading, setLoading] = useState(false);
  const [claimGroup, setClaimGroup] = claimGroupService.useGetClaimGroup(claim_group_id);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { search } = useLocation() //Required for Italy
  const template_type = new URLSearchParams(search).get('template_type')

  useEffect(() => {
    const fetchData = async () => {
      try {
        const template = await reportTemplateService.get(id);
        setSelectedTemplate(template);
      } catch(error) {
        dispatch(handleError(error));
      }
    };
    fetchData();
  }, [dispatch, claim_group_id, id]);

  const handleChange = (event) => {
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    setSelectedTemplate({
      ...selectedTemplate,
      [event.target.name]: value,
    });
  };

  const handleCategoryChange = (event, index) => {
    const templateCategoriesCopy = selectedTemplate.report_template_categories;
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    templateCategoriesCopy[index][event.target.name] = value;
    setSelectedTemplate({
      ...selectedTemplate,
      report_template_categories: templateCategoriesCopy
    });
  };

  const handleTinyMce = (content, index) => {
    const categoriesCopy = selectedTemplate.report_template_categories;
    categoriesCopy[index]['content'] = content;
    setSelectedTemplate({
      ...selectedTemplate,
      report_template_categories: categoriesCopy,
    });
  };

  const handleFinancialAnalysisMethodologyChange = (staffing_cost_methodology, consumables_methodology) => {
    setSelectedTemplate({
      ...selectedTemplate, 
      staffing_cost_methodology, 
      consumables_methodology 
    });
  };

  const updateCompanyOverviewListTypeState = (company_overview_list_type) => {
    setSelectedTemplate({
      ...selectedTemplate,
      company_overview_list_type
    });
  };

  const handleBack = () => {
    history.replace(`/${accountType}/companies/${claimGroup.company_id}/${claimGroup.id}/master`);
  }

  const handleSubmit = async () => {
    setLoading(true);
    try {
      selectedTemplate.report_template_categories_attributes = selectedTemplate.report_template_categories;
      selectedTemplate.claim_report_templates_attributes = selectedTemplate.claim_report_templates;
      await claimGroupReportTemplateService.update(claim_group_id, selectedTemplate, template_type);
      handleToaster('Template Updated');
      history.replace(`/${accountType}/companies/${claimGroup.company_id}/${claimGroup.id}/report_template${REPORT_SAVE_PARAM}`);
    } catch (error) {
      dispatch(handleError(error));
    } finally {
      setLoading(false);
    }
  };

  const handleChangeApplyAymingStyles = async (e, index) => {
    setLoading(true);
    try {
      const reportTemplateCategory = selectedTemplate.report_template_categories[index];
      await reportTemplateCategoryService.update(
        selectedTemplate.id,
        {...reportTemplateCategory, should_apply_styles: e.target.checked}
      );
      const updatedTemplate = await reportTemplateService.get(id);
      setSelectedTemplate(updatedTemplate);
    } catch(err) {
      dispatch(handleError(err))
    } finally {
      setLoading(false);
    }
  };


  if(!selectedTemplate || !claimGroup) return <Loading />;

  return (
    <>
      {!USE_V2_DESIGN && <SidebarPortal headerItem={{link: `companies/${claimGroup.company_id}/master`, text: claimGroup.company.name}} />}
      {USE_V2_DESIGN && <ClaimGroupSidebarV2
        claimGroup={claimGroup}
        company={claimGroup.company}
        claims={claimGroup.claims}
        accountType={accountType}
        highlightedMenuItem='reports'
      />}
      {!USE_V2_DESIGN &&
        <BreadcrumbsPortal>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${accountType}`}}>Home</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${accountType}/companies/${claimGroup.company_id}/master`}}>{claimGroup.company.name}</Breadcrumb.Item>
          </Breadcrumb>
        </BreadcrumbsPortal>
      }

      <Row className={USE_V2_DESIGN ? 'justify-content-center mx-0 mt-4' : ''}>
        <Col md={USE_V2_DESIGN ? 10 : { span: 6, offset: 3 }}>
          <Card>
            <Card.Header>Edit Company Report Template</Card.Header>
            <Card.Body>
              <ReportTemplateForm
                handleChangeApplyAymingStyles={handleChangeApplyAymingStyles}
                handleCategoryChange={handleCategoryChange}
                handleFinancialAnalysisMethodologyChange={handleFinancialAnalysisMethodologyChange}
                updateCompanyOverviewListTypeState={updateCompanyOverviewListTypeState}
                handleTinyMce={handleTinyMce}
                handleChange={handleChange}
                selectedTemplate={selectedTemplate}
                handleBack={handleBack}
                handleSubmit={handleSubmit}
                loading={loading} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default EditClaimGroupReportTemplatePage
